<template>
   <div>
      <template>
         <vx-card class="mb-base mt-5">
            <div class="vx-row">
               <div class="vx-col w-full">
                  <div class="flex items-end px-3">
                     <feather-icon icon="BarChart2Icon" svgClasses="w-5 h-5" class="mr-2 text-primary" />
                     <span class="font-medium text-lg leading-none bold">Perfil fiscal</span>
                     <!-- LOS DATOS PUEDEN SER ACTUALIZADOS POR EL USUARIO SIN RESTRICCION -->
                     <!-- <vs-button v-if="!investorData.fiscalValidationTimestamp" class="ml-auto" size="small" type="border"
                        @click.stop="showFormComponent = true">Editar</vs-button> -->
                     <vs-button v-if="!showFormComponent" class="ml-auto" size="small" type="border"
                        @click.stop="showFormComponent = true">Editar</vs-button>
                     <vs-button v-else class="ml-auto" size="small" type="border"
                        @click.stop="showFormComponent = false">Cancelar</vs-button>
                  </div>
                  <vs-divider />
               </div>
            </div>
            <user-tax-profile :is-edit="showFormComponent" :show-button="showFormComponent" @on-form-saved="onFormSaved"/>
         </vx-card>
      </template>
   </div>
</template>
   
<script>
import UserTaxProfile from '@components/profile_shared/UserTaxProfile';
export default {
   name: "InvestorTaxProfileData",
   components: {
      UserTaxProfile
   },
   data() {
      return {
         isMounted: false,
         investorData: {},
         showFormComponent: false,
      }
   },
   methods: {
      async onFormSaved() {
         this.showFormComponent = false;
      },
   }
}
</script>